export const getSolanaExplorerAddressUrl = (address: string): string => {
  return `https://solscan.io/account/${address}`;
};

export const getSolanaExplorerTxUrl = (signature: string): string => {
  return `https://solscan.io/tx/${signature}`;
};
